import { render, staticRenderFns } from "./DataColumnButtons.vue?vue&type=template&id=5149a1b8&"
import script from "./DataColumnButtons.vue?vue&type=script&lang=js&"
export * from "./DataColumnButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports